import React, { useState, useEffect } from 'react';
import { getActiveAnnouncements, fetchAnnouncementsAsync } from '../../services/storage';

const AnnouncementBar = () => {
    const [announcements, setAnnouncements] = useState(getActiveAnnouncements());
    const [dismissedBanners, setDismissedBanners] = useState({});
    const [popupAnnouncement, setPopupAnnouncement] = useState(null);

    const loadAnnouncements = async () => {
        const active = await fetchAnnouncementsAsync(true);
        setAnnouncements(active);

        // Check if there is any popup announcement that hasn't been shown in this session
        const popup = active.find(item => item.displayType === 'popup' || item.displayType === 'both');
        if (popup) {
            const hasSeenPopup = sessionStorage.getItem(`cafe9_popup_${popup.id}`);
            if (!hasSeenPopup) {
                setPopupAnnouncement(popup);
            }
        }
    };

    useEffect(() => {
        loadAnnouncements();

        const handleUpdate = () => {
            loadAnnouncements();
        };

        window.addEventListener('cafe9_announcements_updated', handleUpdate);
        return () => window.removeEventListener('cafe9_announcements_updated', handleUpdate);
    }, []);

    const handleDismissBanner = (id) => {
        setDismissedBanners(prev => ({ ...prev, [id]: true }));
    };

    const handleClosePopup = () => {
        if (popupAnnouncement) {
            sessionStorage.setItem(`cafe9_popup_${popupAnnouncement.id}`, 'true');
            setPopupAnnouncement(null);
        }
    };

    // Filter banner announcements that are not dismissed
    const bannerList = announcements.filter(
        item => (item.displayType === 'banner' || item.displayType === 'both') && !dismissedBanners[item.id]
    );

    return (
        <>
            {/* Top Banner Announcements */}
            {bannerList.length > 0 && (
                <div className="announcement-wrapper">
                    {bannerList.map(ann => (
                        <aside key={ann.id} className={`announcement-banner banner-${ann.type || 'news'}`} aria-label="Thông báo từ Café 9">
                            <div className="announcement-content">
                                <span className="ann-badge">
                                    <i className={
                                        ann.type === 'promo' ? 'fas fa-gift' :
                                        ann.type === 'schedule' ? 'fas fa-clock' : 'fas fa-bullhorn'
                                    }></i>
                                    {ann.badgeText || (ann.type === 'promo' ? 'Khuyến Mãi' : ann.type === 'schedule' ? 'Lịch Quán' : 'Thông Báo')}
                                </span>
                                
                                <span className="ann-title">{ann.title}</span>
                                <span className="ann-desc">{ann.content}</span>

                                {ann.linkText && ann.linkUrl && (
                                    <a href={ann.linkUrl} className="ann-action-btn">
                                        <span>{ann.linkText}</span>
                                        <i className="fas fa-arrow-right"></i>
                                    </a>
                                )}
                            </div>

                            <button 
                                className="ann-close-btn" 
                                onClick={() => handleDismissBanner(ann.id)}
                                aria-label="Đóng thông báo"
                            >
                                <i className="fas fa-times"></i>
                            </button>
                        </aside>
                    ))}
                </div>
            )}

            {/* Popup Modal Announcement */}
            {popupAnnouncement && (
                <div className="ann-popup-overlay" onClick={handleClosePopup}>
                    <div className="ann-popup-card" onClick={e => e.stopPropagation()}>
                        <button className="ann-popup-close" onClick={handleClosePopup} aria-label="Đóng thông báo">
                            &times;
                        </button>

                        <div className="ann-popup-header">
                            <div className="ann-popup-icon-circle">
                                <i className={
                                    popupAnnouncement.type === 'promo' ? 'fas fa-tag' :
                                    popupAnnouncement.type === 'schedule' ? 'fas fa-calendar-check' : 'fas fa-mug-hot'
                                }></i>
                            </div>
                            <span className="ann-badge">
                                {popupAnnouncement.badgeText || 'Thông Báo Mới'}
                            </span>
                            <h3>{popupAnnouncement.title}</h3>
                        </div>

                        <div className="ann-popup-body">
                            <p>{popupAnnouncement.content}</p>
                        </div>

                        <div className="ann-popup-footer">
                            {popupAnnouncement.linkText && popupAnnouncement.linkUrl ? (
                                <a 
                                    href={popupAnnouncement.linkUrl} 
                                    className="btn btn-primary" 
                                    onClick={handleClosePopup}
                                    style={{ width: '100%' }}
                                >
                                    <span>{popupAnnouncement.linkText}</span>
                                    <i className="fas fa-arrow-right"></i>
                                </a>
                            ) : (
                                <button className="btn btn-primary" onClick={handleClosePopup} style={{ width: '100%' }}>
                                    Đã Hiểu
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default AnnouncementBar;
